import { useTranslation } from 'react-i18next';
import { FlexBox, Icon, IconButton } from '@vp/swan';
import { useStyles } from '@vp/ubik-context';
import styles, { stylesheet } from './VideoControls.module.scss';

interface VideoControlsProps {
    isMuted: boolean;
    isPlaying: boolean;
    isCaptioning: boolean;
    onMuteToggle: () => void;
    onPlayPause: () => void;
    onCaptioningToggle: () => void;
}

const VideoControls = ({
    isMuted,
    isPlaying,
    isCaptioning,
    onMuteToggle,
    onPlayPause,
    onCaptioningToggle,
}: VideoControlsProps) => {
    useStyles(stylesheet);

    const { t } = useTranslation();
    const playTooltip = t(
        'Logomaker GenAi Landing Page > Feature Banner How It Works > Media Control > Tooltip > Play.value',
    );
    const pauseTooltip = t(
        'Logomaker GenAi Landing Page > Feature Banner How It Works > Media Control > Tooltip > Pause.value',
    );
    const mutedTooltip = t(
        'Logomaker GenAi Landing Page > Feature Banner How It Works > Media Control > Tooltip > Muted.value',
    );
    const unmutedTooltip = t(
        'Logomaker GenAi Landing Page > Feature Banner How It Works > Media Control > Tooltip > Unmuted.value',
    );
    const captionsOnTooltip = t(
        'Logomaker GenAi Landing Page > Feature Banner How It Works > Media Control > Tooltip > Captions On.value',
    );
    const captionsOffTooltip = t(
        'Logomaker GenAi Landing Page > Feature Banner How It Works > Media Control > Tooltip > Captions Off.value',
    );

    const playPauseTooltipText = isPlaying ? pauseTooltip : playTooltip;
    const muteTooltipText = isMuted ? mutedTooltip : unmutedTooltip;
    const captionsTooltipText = isCaptioning ? captionsOnTooltip : captionsOffTooltip;

    return (
        <FlexBox
            justifyContent="space-between"
            alignItems="stretch"
            className={styles.controllersWrapper}
        >
            <IconButton
                className={styles.mediaController}
                skin="secondary"
                tooltip={captionsTooltipText}
                onClick={onCaptioningToggle}
                aria-label={captionsTooltipText}
            >
                <Icon iconType={isCaptioning ? 'closedCaptionsOn' : 'closedCaptionsOff'} />
            </IconButton>
            <FlexBox gap={3}>
                <IconButton
                    className={styles.mediaController}
                    skin="secondary"
                    tooltip={muteTooltipText}
                    onClick={onMuteToggle}
                    aria-label={muteTooltipText}
                >
                    <Icon iconType={isMuted ? 'soundOff' : 'soundOn'} />
                </IconButton>
                <IconButton
                    className={styles.mediaController}
                    skin="secondary"
                    tooltip={playPauseTooltipText}
                    onClick={onPlayPause}
                    aria-label={playPauseTooltipText}
                >
                    <Icon iconType={isPlaying ? 'pause' : 'play'} skin="standard" />
                </IconButton>
            </FlexBox>
        </FlexBox>
    );
};

export default VideoControls;
